import styles from "./RecommendationsSection.module.css";
import firstImage from "../../../../assets/images/pages/ParentsMarathon/section-6-mother-child.png"

const CheckCircle = () => (
  <svg
    className={styles.listMarker}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="9" fill="#00A63E" stroke="#00A63E" strokeWidth="2" />
    <path d="M6 10L9 13L14 7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LEFT_ITEMS = [
  "Занимайтесь ежедневно от 15–30 минут в спокойной обстановке.",
  "Повторяйте одни и те же задания регулярно.",
  "Создавайте повод для речи.",
] as const;

const RIGHT_ITEMS = [
  "Любой звук, взгляд, жест — это шаг вперёд! Хвалите за попытку.",
  "Используйте короткие фразы, чёткую артикуляцию, эмоциональную интонацию.",
] as const;

export const RecommendationsSection = () => {
  return (
    <section className={styles.section} aria-label="Общие рекомендации">
      <div className={styles.container}>
        <div className={styles.card}>
          <img src={firstImage} alt="sction-6-mother-child" />

          <div className={styles.cardContent}>
            <h2 className={styles.title}>
              Общие рекомендации{" "}
              <span className={styles.emoji} aria-hidden="true">📖</span>
            </h2>

            <div className={styles.columns}>
              <ul className={styles.list}>
                {LEFT_ITEMS.map((item) => (
                  <li key={item} className={styles.listItem}>
                    <CheckCircle />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <ul className={styles.list}>
                {RIGHT_ITEMS.map((item) => (
                  <li key={item} className={styles.listItem}>
                    <CheckCircle />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};